import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Divider, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, IconButton } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { Menu as MenuIcon } from '@mui/icons-material';

const styles = {
  root: {
    flexGrow: 1,
  },
  label: (theme) => ({
    marginRight: theme.spacing(2),
    fontSize: 14,
  }),
  title: {
    flexGrow: 1,
  },
  toolbarContent: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px',
    marginLeft: 'auto',
  },
  pagination: {
    display: 'inline-flex',
    marginLeft: '100px',
  },
  inputElement: {
    fontSize: 14,
    width: 50,
    padding: 0,
  },
  divider: {
    margin: '0 24px',
  },
};

function TranslationFieldsPagination(props) {

  const [page, setPage] = useState(props.currentPage || 1);
  const [totalPages, setTotalPages] = useState(Math.ceil(props.totalCount / props.perPage));
  const [dialogOpen, setDialogOpen] = useState(false);
  const [inputPage, setInputPage] = useState(props.currentPage);

  useEffect(() => {
    setPage(props.currentPage);
    setInputPage(props.currentPage);
  }, [props.currentPage]);


  const handlePageChange = (event, value) => {
    setPage(value);
    props.subfieldsPaginateFunc[props.scope](props.itemId, value);
  };

  const handlePageInputChange = (e) => {
    const parsedPage = parseInt(inputPage, 10);
    if (!isNaN(parsedPage)) {
      if (parsedPage > 0 && parsedPage <= totalPages) {
        setPage(parsedPage);
        props.subfieldsPaginateFunc[props.scope](props.itemId, parsedPage);
      }
      else {
        setInputPage(page);
      }
    }
  };

  return (
    <div>
      {props.position == 'above' && <Divider sx={styles.divider} />}
      <Toolbar variant="dense" sx={styles.root}>
        <div style={styles.toolbarContent}>

          <span style={{ marginRight: 16, fontSize: 14 }}>Current Page:</span>
          <TextField
            type="number"
            //label="Page Number"
            value={inputPage}
            onBlur={handlePageInputChange}
            onChange={(e) => setInputPage(e.target.value)}
            inputProps={{ min: 1 }}
            margin="dense"
            size="small"
            InputProps={{
              sx: {
                '& input': styles.inputElement,
              },
            }} />
          <Pagination sx={styles.pagination} count={totalPages} page={page} onChange={handlePageChange} color="inherit" />
        </div>
      </Toolbar>
      {props.position == 'below' && <Divider sx={styles.divider} />}
    </div>
  );
}

export default TranslationFieldsPagination;
